import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantHomePage } from './merchant-home';

@NgModule({
  declarations: [
    MerchantHomePage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantHomePage),
    TranslateModule.forChild()
  ],
})
export class MerchantHomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-home/merchant-home.module.ts